import React, { useEffect, useState } from 'react';

const no_hq_location = {
  "id": null
}

function SearchableDropdown({options, selectedValue, preset = null}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  const toggleDropdown = () => {
    setSearchTerm("");
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    if(option === "none") {
      setSelectedOption(null);
      selectedValue(no_hq_location);
    } else {
      setSelectedOption(option.name);
      selectedValue(option);
    }
    toggleDropdown();
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    if (preset && !selectedOption){
      setSelectedOption(preset.name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preset])

  let filteredOptions = options;

  if(searchTerm.length) {
    filteredOptions = options.filter((option) =>
      option.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  // if there are no location to list: show message instead
  if(options && !options.length) {
    return (
      <div className="hq-option">
        <label>
          <span className="label-text">* HQ LOCATION:</span>
          <div className="drop-options no-options">
            <span className="hq-label-no-icon">No Locations Found</span>
          </div>
        </label>
      </div>
    )
  }

  return (
    <div className="hq-option">
      <label>
        <span className="label-text">* HQ LOCATION:</span>
        <div className="drop-options" onClick={toggleDropdown}>
          {selectedOption ? 
            <span className="hq-label-no-icon">{selectedOption}</span> : 
            <span className="hq-label">Select an Option <i className="bi bi-geo-alt"/></span>
          }
        </div>
        {isOpen && 
          <div className="hq-content">
            <input
              type="text"
              placeholder="Search a location..."
              value={searchTerm}
              onChange={handleInputChange}
              onClick={(e) => e.stopPropagation()}
              className="hq-search"
            />
            <div className="hq-item-wrapper small-scrollbars">
              {!searchTerm.length && selectedOption &&
                <div 
                  className="hq-item" 
                  onClick={() => handleOptionClick("none")} 
                  key="00:001">
                    NONE <i className="bi bi-dash-circle delete-hq"/>
                </div>
              }
              
              {filteredOptions.map((option) => (
                <div 
                  className="hq-item" 
                  onClick={() => handleOptionClick(option)} 
                  key={option.id}
                  title={`${option.address1}, ${option.city}, ${option.state} ${option.zip5}`}
                >
                    {option.name}
                </div>
              ))}
            </div>
          </div>
        }
      </label>
    </div>
  )

}

export default SearchableDropdown;
